var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import './lightbox.styles.scss';
var LightBox = /** @class */ (function (_super) {
    __extends(LightBox, _super);
    function LightBox(props) {
        var _this = _super.call(this, props) || this;
        _this.openBox = function (withSlideIndex) { return function () {
            _this.setState({ slideIndex: withSlideIndex, showModal: true });
        }; };
        _this.closeBox = function () {
            _this.setState({ slideIndex: 0, showModal: false });
        };
        _this.handleKeyboardEvents = function (event) {
            var key = event.key;
            switch (key) {
                case 'ArrowLeft':
                    _this.prevImage();
                    break;
                case 'ArrowRight':
                    _this.nextImage();
                    break;
                case 'Escape':
                    _this.closeBox();
                    break;
                default:
                    return;
            }
        };
        _this.prevImage = function () {
            _this.setState(function (prevState) {
                var slideIndex = prevState.slideIndex;
                if (slideIndex > 0) {
                    return { slideIndex: slideIndex - 1 };
                }
                else {
                    return { slideIndex: 0 };
                }
            });
        };
        _this.nextImage = function () {
            var images = _this.props.images;
            _this.setState(function (prevState) {
                var slideIndex = prevState.slideIndex;
                if (slideIndex <= images.length - 2)
                    return { slideIndex: slideIndex + 1 };
                else
                    return { slideIndex: images.length - 1 };
            });
        };
        _this.renderThumbs = function () {
            var _a = _this.props, images = _a.images, maxThumbnailCount = _a.maxThumbnailCount;
            var thumbnailCount = images.length < maxThumbnailCount ? images.length : maxThumbnailCount;
            return (React.createElement("button", { className: "row", onClick: _this.openBox(0) },
                Array(thumbnailCount)
                    .fill(0)
                    .map(function (element, index) { return (React.createElement("div", { className: "column" },
                    React.createElement("img", { src: images[index].image, onClick: _this.openBox(index), className: "hover-shadow cursor thumb", alt: images[index].caption || 'image thumb' }))); }),
                thumbnailCount !== images.length && (React.createElement("span", { className: "more-images-text" },
                    ' ',
                    "+ ",
                    images.length - thumbnailCount,
                    " More"))));
        };
        _this.renderPrevButton = function () {
            var slideIndex = _this.state.slideIndex;
            if (slideIndex > 0) {
                return (React.createElement("button", { className: "prev", onClick: function () { return _this.prevImage(); } }, "\u276E"));
            }
            return null;
        };
        _this.renderNextButton = function () {
            var slideIndex = _this.state.slideIndex;
            if (slideIndex <= _this.props.images.length - 2) {
                return (React.createElement("button", { className: "next", onClick: function () { return _this.nextImage(); } }, "\u276F"));
            }
            return null;
        };
        _this.state = {
            slideIndex: 0,
            showModal: false,
        };
        return _this;
    }
    LightBox.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.handleKeyboardEvents);
    };
    LightBox.prototype.render = function () {
        var _this = this;
        var _a = this.state, slideIndex = _a.slideIndex, showModal = _a.showModal;
        var images = this.props.images;
        return (React.createElement("div", { className: "lightbox-container" },
            this.renderThumbs(),
            React.createElement("div", { className: "modal", style: { display: "" + (showModal ? 'block' : 'none') } },
                React.createElement("span", { className: "close cursor", onClick: function () { return _this.closeBox(); } }, "\u00D7"),
                React.createElement("div", { className: "modal-content" },
                    React.createElement("div", { className: "slides" },
                        React.createElement("div", { className: "number-text" }, slideIndex + 1 + " / " + images.length),
                        React.createElement("img", { className: "display-img", src: images[slideIndex]
                                ? images[slideIndex].image
                                : images[0].image, alt: images[slideIndex]
                                ? images[slideIndex].caption
                                : 'image-slide' })),
                    this.renderPrevButton(),
                    this.renderNextButton(),
                    React.createElement("div", { className: "caption-container" },
                        React.createElement("p", { id: "caption" }))))));
    };
    return LightBox;
}(React.Component));
export default LightBox;
//# sourceMappingURL=lightbox.js.map